// utils/formatItems.js
import React from "react";

export function formatItemFragment(name, quantity, min, max) {
  const qty = Number(quantity) > 1 ? `${quantity}x ` : "";
  let val = "";
  if (min != null && max != null) {
    val = min === max ? ` (${min})` : ` (${min}-${max})`;
  } else if (min != null) {
    val = ` (${min})`;
  }
  return (
    <>
      {qty}{name}{val}
    </>
  );
}
